import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=c5857270&scoped=true&"
import script from "./Signature.ts?vue&type=script&lang=js&"
export * from "./Signature.ts?vue&type=script&lang=js&"
import style0 from "./Signature.vue?vue&type=style&index=0&id=c5857270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5857270",
  null
  
)

export default component.exports